import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormArray, FormGroup, FormGroupDirective, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Sgke141aRequest, Sgke141aResponseInitialhyojiInfo, Sgke142aRequest, Sgke142aResponseGamenHyojiInfo, Sgke142aResponseInitialhyojiInfo, Sgke143aRequest, Sgke144aRequest, Sgke145aRequest } from 'sg-api';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { Sgkz004dComponent } from '../../../../../../sg-base/sg-base-shared/pages/sgkz004d/components/sgkz004d.component';
import { UsedSgke141aService } from '../../services/used-sgke141a.service';
import { UsedSgke142aService } from '../../services/used-sgke142a.service';
import { UsedSgke143aService } from '../../services/used-sgke143a.service';
import { UsedSgke144aService } from '../../services/used-sgke144a.service';
import { UsedSgke145aService } from '../../services/used-sgke145a.service';
import { ResponseMsgUtils } from '../../../../../sg-ke-shared/util/response-msg-utils';

@Component({
  selector: 'app-sgke140d',
  templateUrl: './sgke140d.component.html',
  styleUrl: './sgke140d.component.scss'
})
export class Sgke140dComponent implements OnInit, OnDestroy {

  /** モーダル表示フラグ */
  @Input() isMordal: boolean = false;
  /** 編集フラグ */
  @Input() isEdit: boolean = false;
  /** 入金突合結果管理番号 */
  @Input() rcvmnyReconciliationresultMno: string = null;
  /** 入金突合結果_更新通番号 */
  @Input() rcvmnyreconciliationResultUpdatesequencenumber: string = null;
  /** 手数料管理番号 */
  @Input() feeMno: string = null;
  /** 手数料履歴番号 */
  @Input() feeRrkno: string = null;
  /** 手数料_更新通番号 */
  @Input() feeUpdatesequencenumber: string = null;

  /** メッセージエリア */
  @Output() errorMessageModelArray: Array<SgAriaMessage> = new Array<SgAriaMessage>();
  /** ダイアログクローズイベント*/
  @Output() dialogCloseEmitter = new EventEmitter();

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();
  /** 初期表示（作業管理）APIリクエスト */
  private request141a: Sgke141aRequest;
  /** 初期表示（入金突合）APIリクエスト */
  private request142a: Sgke142aRequest;

  /** 手数料報告登録APIリクエストDto FormGroup */
  regInfRequestForm: UntypedFormGroup;
  /** 初期表示情報（作業管理）_APIレスポンス */
  newInitialhyojiInfo: Sgke141aResponseInitialhyojiInfo;
  /** 初期表示情報_初期表示（入金突合）APIレスポンス */
  correctionInitialhyojiInfo: Sgke142aResponseInitialhyojiInfo;
  /** 画面表示情報_初期表示（入金突合）APIレスポンス */
  gamenHyojiInfo: Sgke142aResponseGamenHyojiInfo;
  /** FormGroupDirective */
  private formGroupDirective: FormGroupDirective;

  /**
   * コンストラクタ
   * @param {UsedSgke141aService} newSearchService
   * @param {UsedSgke142aService} correctionSearchService
   * @param {UsedSgke143aService} newRegistService
   * @param {UsedSgke144aService} correctionRegistService
   * @param {UsedSgke145aService} deleteService
   * @param {MatDialog} dialog
   * @param {UntypedFormBuilder} fb
   * @param {Router} router 
   * @param {ResponseMsgUtils} responseMsgUtils 
   * @param {ChangeDetectorRef} cd
   * @memberof Sgke140dComponent
   */
  constructor(
    public newSearchService: UsedSgke141aService,
    public correctionSearchService: UsedSgke142aService,
    public newRegistService: UsedSgke143aService,
    public correctionRegistService: UsedSgke144aService,
    public deleteService: UsedSgke145aService,
    public dialog: MatDialog,
    private fb: UntypedFormBuilder,
    private router: Router,
    public responseMsgUtils: ResponseMsgUtils,
    private cd: ChangeDetectorRef,
  ) { }

  /**
   * 初期処理
   * @memberof Sgke140dComponent
   */
  ngOnInit(): void {
    this.init();
  }

  /**
   * 購読解除
   * @memberof Sgke140dComponent
   */
  ngOnDestroy() {
    //購読を停止する処理
    this.onDestroy$.next();
  }

  /**
   * 登録処理
   * @memberof Sgke140dComponent
   */
  regist(formDirective: FormGroupDirective) {
    this.clearErrorMsg();

    this.formGroupDirective = formDirective;

    if (this.isEdit) {
      // 訂正の場合

      // 手数料種類/手数料額を取得
      const reginfFormGroup = this.regInfRequestForm.controls['reginf'] as FormGroup;
      const feeContFormArray = reginfFormGroup.get('feeCont') as FormArray;

      feeContFormArray.controls.forEach(group => {
        // 手数料種類名称はリクエスト情報に含めないため非活性化
        group.get('feeSyuruiAname').disable();
      });

      const request: Sgke144aRequest = {
        // UsedService側で設定するため、ここではnullを設定する
        requestCommon: null,
        reqBusinessArea: {
          // 更新情報
          updateInfo: {
            // 入金突合結果管理番号
            rcvmnyReconciliationresultMno: this.rcvmnyReconciliationresultMno,
            // 手数料管理番号
            feeMno: this.feeMno,
            // 手数料履歴番号
            feeRrkno: this.feeRrkno,
            // 手数料_更新通番号
            feeUpdatesequencenumber: this.feeUpdatesequencenumber,
            // 入金突合結果_更新通番号
            rcvmnyreconciliationResultUpdatesequencenumber: this.rcvmnyreconciliationResultUpdatesequencenumber,
          },
          // 手数料内容
          feeCont: feeContFormArray.value
        }
      }

      // SGKE144A呼び出し
      this.correctionRegistService.doSgke144a(request)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          this.handleResponse,
          error => {
          });
    } else {
      // 新規登録/登録の場合

      // Form情報をリクエスト用に変換
      this.convertFormToRequestData();
      // 活性状態の値を取得
      let request = this.regInfRequestForm.value as Sgke143aRequest;
      // リクエスト用に変換したForm情報を戻す
      this.convertRequestToFormData();

      request.reginf = {
        ...request.reginf,
        // 入金突合結果管理番号
        rcvmnyReconciliationresultMno: this.rcvmnyReconciliationresultMno,
        // 入金突合結果_更新通番号
        rcvmnyreconciliationResultUpdatesequencenumber: this.rcvmnyreconciliationResultUpdatesequencenumber,
        // 手数料管理番号
        feeMno: this.feeMno,
        // 手数料履歴番号
        feeRrkno: this.feeRrkno,
      };

      // SGKE143A呼び出し
      this.newRegistService.doSgke143a(request)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          this.handleResponse,
          error => {
          });
    }

  }

  /**
   * 削除処理
   * @memberof Sgke140dComponent
   */
  remove() {
    this.clearErrorMsg();

    const request: Sgke145aRequest = {
      // UsedService側で設定するため、ここではnullを設定する
      requestCommon: null,
      reqBusinessArea: {
        delInfo: {
          // 入金突合結果管理番号
          rcvmnyReconciliationresultMno: this.rcvmnyReconciliationresultMno,
          // 入金突合結果_更新通番号
          rcvmnyreconciliationResultUpdatesequencenumber: this.rcvmnyreconciliationResultUpdatesequencenumber,
          // 手数料管理番号
          feeMno: this.feeMno,
          // 手数料履歴番号
          feeRrkno: this.feeRrkno,
          // 手数料_更新通番号
          feeUpdatesequencenumber: this.feeUpdatesequencenumber,
          // 手数料明細管理番号
          feeMeisaiMno: this.gamenHyojiInfo.feeRegUnit.map(target => {
            return target.feeMeisaiMno;
          })
        }
      }
    }

    // SGKE145A呼び出し
    this.deleteService.doSgke145a(request)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        this.handleResponse,
        error => {
        });
  }

  /**
   * キャンセル処理
   * @memberof Sgke140dComponent
   */
  cancel() {
    this.clearErrorMsg();

    if (this.isMordal) {
      // モーダル画面の場合、モーダルを閉じる
      this.dialogCloseEmitter.emit(this.errorMessageModelArray);
    } else {
      // 作業管理画面に遷移
      this.router.navigate(['/sgkz001d/']);
    }
  }

  /**
   * アイコン押下処理
   * @memberof Sgke140dComponent
   */
  onClickIcon() {
    // 実行履歴情報画面モーダルを表示
    this.dialog.open(Sgkz004dComponent, {
      disableClose: true, // 背景クリックのクローズ禁止
      data: {
        // 履歴管理グループ OT_SGKEFEE（手数料）を設定
        historyManagementGroup: 'OT_SGKEFEE',
        // 履歴管理キー 手数料管理番号を設定
        historyManagementKey: this.feeMno,
        // 承認欄表示フラグに'0'を設定
        apprvOnFlg: '0'
      },
    });
  }

  /**
   * 初期表示（新規）_検索処理
   * @private
   * @memberof Sgke140dComponent
   */
  private newInitSearch() {
    // sgke141aのリクエスト情報をもつオブジェクトを定義
    this.request141a = {
      requestCommon: null,
    };

    // SGKE141A呼び出し
    this.newSearchService.doSgke141a(this.request141a)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        if (response?.initialhyojiInfo) {
          this.newInitialhyojiInfo = response.initialhyojiInfo;
        }
        // メッセージ表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
      },
        error => {
        });
  }

  /**
   * 初期表示（作業管理）_検索処理
   * @private
   * @memberof Sgke140dComponent
   */
  private correctionInitSearch() {
    // sgke142aのリクエスト情報をもつオブジェクトを定義
    this.request142a = {
      requestCommon: null,
      shtkInfo: {
        rcvmnyReconciliationresultMno: this.rcvmnyReconciliationresultMno,
        feeMno: this.feeMno,
        feeRrkno: this.feeRrkno,
        rcvmnyreconciliationResultUpdatesequencenumber: this.rcvmnyreconciliationResultUpdatesequencenumber,
        feeUpdatesequencenumber: this.feeUpdatesequencenumber,
      }
    };

    // SGKE142A呼び出し
    this.correctionSearchService.doSgke142a(this.request142a)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        if (response?.initialhyojiInfo) {
          this.correctionInitialhyojiInfo = response.initialhyojiInfo;
          this.gamenHyojiInfo = response.gamenHyojiInfo;
        }
        // メッセージ表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
      },
        error => {
        });
  }

  /**
   * エラーメッセージ表示領域をクリア
   * @private
   * @memberof Sgke140dComponent
   */
  private clearErrorMsg() {
    this.errorMessageModelArray = new Array<SgAriaMessage>();
    this.cd.detectChanges();
  }

  /**
   * レスポンス共通処理
   * @private
   * @param {any} response 
   * @memberof Sgke140dComponent
   */
  private handleResponse = (response: any): void => {
    if (response) {
      if (this.isMordal) {
        this.dialogCloseEmitter.emit(response?.responseCommon?.errors);
      } else {
        // メッセージを表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
        if (this.formGroupDirective) {
          this.formGroupDirective.resetForm();
        }
        // 初期表示処理
        this.init();
      }
    }
  }

  /**
   * フォーム情報をリクエスト用に変換する
   * @private
   * @memberof Sgke140dComponent
   */
  private convertFormToRequestData() {
    const regInfFormGroup = this.regInfRequestForm.controls['reginf'] as FormGroup;
    if (this.isMordal) {
      // 会社を活性化
      regInfFormGroup.controls['companycode'].enable();
      // 入金地区を活性化
      regInfFormGroup.controls['rcvmnyAreacode'].enable();
      // 口座入金日を活性化
      regInfFormGroup.controls['kouzaRcvmnyDate'].enable();
      // 入金口座を活性化
      regInfFormGroup.controls['rcvmnyKouzacode'].enable();
      // 入金形態を活性化
      regInfFormGroup.controls['rcvmnyKeitaiCode'].enable();
      // 口座入金機関を活性化
      regInfFormGroup.controls['kouzaRcvmnyBankofficecode'].enable();

    }

    const feeContFormArray = regInfFormGroup.get('feeCont') as FormArray;
    feeContFormArray.controls.forEach(group => {
      // リクエスト情報では手数料種類名称は不要のため、非活性状態にする
      group.get('feeSyuruiAname').disable();

    });

  }

  /**
   * リクエスト用に変換したフォーム情報を戻す
   * @private
   * @memberof Sgke140dComponent
   */
  private convertRequestToFormData() {
    const regInfFormGroup = this.regInfRequestForm.controls['reginf'] as FormGroup;
    if (this.isMordal) {
      // 会社を非活性化
      regInfFormGroup.controls['companycode'].disable();
      // 入金地区を非活性化
      regInfFormGroup.controls['rcvmnyAreacode'].disable();
      // 口座入金日を非活性化
      regInfFormGroup.controls['kouzaRcvmnyDate'].disable();
      // 入金口座を非活性化
      regInfFormGroup.controls['rcvmnyKouzacode'].disable();
      // 入金形態を非活性化
      regInfFormGroup.controls['rcvmnyKeitaiCode'].disable();
      // 口座入金機関を非活性化
      regInfFormGroup.controls['kouzaRcvmnyBankofficecode'].disable();
    }

    const feeContFormArray = regInfFormGroup.get('feeCont') as FormArray;
    feeContFormArray.controls.forEach(group => {
      // 手数料種類名称を活性化
      const feeSyuruiAnameControl = group.get('feeSyuruiAname');
      feeSyuruiAnameControl.enable();
    });

  }

  /**
   * 初期表示処理
   * @memberof Sgke140dComponent
   */
  private init() {
    // 初期表示検索結果初期化
    this.newInitialhyojiInfo = null;
    this.correctionInitialhyojiInfo = null;

    // 登録情報のFormを初期化
    this.regInfRequestForm = this.fb.group({
      requestCommon: new UntypedFormGroup({}),
    });

    if (this.isMordal) {
      this.correctionInitSearch();
    } else {
      this.newInitSearch();
    }

  }

}
